import { Button, Portal } from '@chakra-ui/react';
import { CloseButton } from '@ui/components/CloseButton';
import { DialogOrDrawer } from '@ui/components/DialogOrDrawer';
import React from 'react';

import { H2SlippageInput } from './H2SlippageInput';
import { useH2SwapSlippageDialog } from './useH2SwapSlippageDialog';

export const H2SwapSlippageDialog = () => {
  const isOpen = useH2SwapSlippageDialog((s) => s.isOpen);
  const confirm = useH2SwapSlippageDialog((s) => s.confirm);
  const close = useH2SwapSlippageDialog((s) => s.close);

  return (
    <DialogOrDrawer.Root
      size={{
        desktopDown: 'lg',
        desktop: 'sm',
      }}
      placement={{
        desktopDown: 'bottom',
        desktop: 'top',
      }}
      scrollBehavior="inside"
      closeOnInteractOutside={false}
      open={isOpen}
      onOpenChange={(state) => !state.open && close()}
    >
      <DialogOrDrawer.Backdrop />
      <Portal>
        <DialogOrDrawer.Positioner>
          <DialogOrDrawer.DragContent
            minH={{
              base: '500px',
              desktop: 'min(700px, 80dvh)',
            }}
          >
            <DialogOrDrawer.CloseTrigger asChild>
              <CloseButton onClick={close} />
            </DialogOrDrawer.CloseTrigger>
            <DialogOrDrawer.Header>
              <DialogOrDrawer.Title>Slippage Settings</DialogOrDrawer.Title>
            </DialogOrDrawer.Header>
            <DialogOrDrawer.Body pt="24px">
              <H2SlippageInput />
            </DialogOrDrawer.Body>

            <DialogOrDrawer.Footer alignItems="stretch">
              <Button w="full" onClick={confirm}>
                Confirm
              </Button>
            </DialogOrDrawer.Footer>
          </DialogOrDrawer.DragContent>
        </DialogOrDrawer.Positioner>
      </Portal>
    </DialogOrDrawer.Root>
  );
};
